import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/restart.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm restart [-- <args>]
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/restart.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <h3>{`Description`}</h3>
    <p>{`This restarts a project.  It is equivalent to running `}<inlineCode parentName="p">{`npm run-script
restart`}</inlineCode>{`.`}</p>
    <p>{`If the current project has a `}<inlineCode parentName="p">{`"restart"`}</inlineCode>{` script specified in
`}<inlineCode parentName="p">{`package.json`}</inlineCode>{`, then the following scripts will be run:`}</p>
    <ol>
      <li parentName="ol">{`prerestart`}</li>
      <li parentName="ol">{`restart`}</li>
      <li parentName="ol">{`postrestart`}</li>
    </ol>
    <p>{`If it does `}<em parentName="p">{`not`}</em>{` have a `}<inlineCode parentName="p">{`"restart"`}</inlineCode>{` script specified, but it does have
`}<inlineCode parentName="p">{`stop`}</inlineCode>{` and/or `}<inlineCode parentName="p">{`start`}</inlineCode>{` scripts, then the following scripts will be run:`}</p>
    <ol>
      <li parentName="ol">{`prerestart`}</li>
      <li parentName="ol">{`prestop`}</li>
      <li parentName="ol">{`stop`}</li>
      <li parentName="ol">{`poststop`}</li>
      <li parentName="ol">{`prestart`}</li>
      <li parentName="ol">{`start`}</li>
      <li parentName="ol">{`poststart`}</li>
      <li parentName="ol">{`postrestart`}</li>
    </ol>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`ignore-scripts`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`If true, npm does not run scripts specified in package.json files.`}</p>
    <p>{`Note that commands explicitly intended to run a particular script, such as
`}<inlineCode parentName="p">{`npm start`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm stop`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm restart`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm test`}</inlineCode>{`, and `}<inlineCode parentName="p">{`npm run-script`}</inlineCode>{`
will still run their intended script if `}<inlineCode parentName="p">{`ignore-scripts`}</inlineCode>{` is set, but they
will `}<em parentName="p">{`not`}</em>{` run any pre- or post-scripts.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`script-shell`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: '/bin/sh' on POSIX systems, 'cmd.exe' on Windows`}</li>
      <li parentName="ul">{`Type: null or String`}</li>
    </ul>
    <p>{`The shell to use for scripts run with the `}<inlineCode parentName="p">{`npm exec`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm run`}</inlineCode>{` and `}<inlineCode parentName="p">{`npm
init <package-spec>`}</inlineCode>{` commands.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-run-script"
        }}>{`npm run-script`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/scripts"
        }}>{`npm scripts`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-test"
        }}>{`npm test`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-start"
        }}>{`npm start`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-stop"
        }}>{`npm stop`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-restart"
        }}>{`npm restart`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      